import { Tab as MUITab } from '@material-ui/core';
import styled from 'styled-components';

export const Tab = styled(MUITab)`
  font-size: 1.2rem !important;
  font-weight: bold !important;
  text-transform: none !important;
`;
